<template>
    <div>
        <v-row no-gutters>
            <v-col cols="4">
                <h1 class="headline font-weight-light">
                    HP Part
                </h1>
            </v-col>
            <v-col cols="3" class="text-right">
                <v-text-field
                    v-model="form_search.search"
                    color="purple darken-2"
                    label="Search"
                    required
                >
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-btn class="mt-4" small color="primary" @click="get_data()">
                    <v-icon small color="white">mdi-magnify</v-icon> SEARCH
                </v-btn>
                <v-btn
                    class="mt-4 ml-4"
                    small
                    color="warning"
                    @click="clear_data()"
                    >clear
                </v-btn>
            </v-col>
            <v-col cols="3" class="text-right">
                <v-tooltip>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            small
                            :color="
                                chk_export_data == false ? 'green accent-3' : ''
                            "
                            :disabled="chk_export_data == true"
                            class="mr-1 mt-2"
                            @click="export_data()"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                v-if="chk_export_data == false"
                                color="teal darken-4"
                                >mdi-file-excel</v-icon
                            >
                            <img
                                v-if="chk_export_data == true"
                                src="../../../assets/all/Loading.gif"
                                style="width:6%; "
                            />
                        </v-btn>
                    </template>
                    <span>Export Data</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-card outlined class="mt-2">
            <v-list-item>
                <v-list-item-content>
                    <v-row v-for="(row, index) in data_case.data" :key="index">
                        <v-col cols="12" v-if="index > 0" class="mar-t-10 mb-5">
                            <hr />
                            <hr />
                        </v-col>
                        <v-col cols="10" md="6" style="background-color:#FFF">
                            <v-chip small color="green accent-3" class="ml-2">{{
                                row.case_id + "-" + row.subcase
                            }}</v-chip>
                            <v-chip small class="ml-1 mr-1" color="lime">
                                {{ row.created_name }}</v-chip
                            >
                            <v-chip small>{{ row.created_date }}</v-chip>
                            <ViewMore
                                v-if="row.nonhp_maincase_id"
                                class="fix-flex-end-row mar-t-30"
                                :maincaseid="row.nonhp_maincase_id"
                            />
                        </v-col>
                        <v-col cols="10" md="4" style="background-color:#FFF">
                            <b>Serial :</b> {{ row.product_serial }}
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col
                            cols="2"
                            style="background-color:#FFF"
                            class="text-right"
                        >
                            <v-btn
                                rounded
                                small
                                color="success"
                                :disabled="chk_btn(row.parts) == true"
                                @click="
                                    open_update_case(
                                        row.maincase_id,
                                        row.subcase_id
                                    )
                                "
                                >Update Case</v-btn
                            >
                        </v-col>
                        <v-col cols="12" md="6">
                            <b>Case Title :</b> {{ row.case_title }}
                        </v-col>
                        <v-col cols="12" md="6">
                            <b>Site Name :</b> {{ row.site_name }}
                        </v-col>

                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">
                                                #
                                            </th>
                                            <th class="text-center">
                                                PO Number
                                            </th>
                                            <th class="text-center">
                                                Part Name
                                            </th>
                                            <th class="text-center">
                                                Part Description
                                            </th>
                                            <th class="text-center">
                                                Ship Date
                                            </th>
                                            <th class="text-center">
                                                Onhand
                                            </th>
                                            <th class="text-center">
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(r, i) in row.parts"
                                            :key="i"
                                        >
                                            <td>{{ i + 1 }}.</td>
                                            <td>{{ r.ponumber }}</td>
                                            <td>{{ r.part_name }}</td>
                                            <td>{{ r.part_description }}</td>
                                            <td>
                                                {{
                                                    r.ship_date_x == null
                                                        ? r.status
                                                        : r.ship_date_x
                                                }}
                                            </td>
                                            <td>{{ r.onhand_date_x }}</td>
                                            <td class="text-center">
                                                <v-btn
                                                    :disabled="
                                                        r.onhand_date_x == null
                                                    "
                                                    rounded
                                                    small
                                                    :color="
                                                        r.ce_status
                                                            ? 'amber'
                                                            : 'red accent-2'
                                                    "
                                                    @click="
                                                        open_update_part(
                                                            r.part_issue_id
                                                        )
                                                    "
                                                    >{{
                                                        r.ce_status
                                                            ? r.ce_status
                                                            : "Update Status"
                                                    }}</v-btn
                                                >
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
        </v-card>
        <div class="text-center pb-5 pt-4">
            <div>
                <v-btn class="mx-2" fab small @click="back()">
                    <v-icon dark small>mdi-chevron-left</v-icon>
                </v-btn>

                <v-btn
                    class="mx-2"
                    fab
                    small
                    :color="btn_color(n)"
                    v-for="n in page_count"
                    :key="n"
                    @click="get_page(page_num_show(n))"
                    >{{ page_num_show(n) }}</v-btn
                >

                <v-btn class="mx-2" fab small @click="next()">
                    <v-icon dark small>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="450">
                <v-card>
                    <v-card-title class="headline">
                        Update Case
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    :items="['Complete', 'Quotation', 'Cancel']"
                                    v-model="main.status"
                                    required
                                    hide-details
                                    dense
                                    outlined
                                    label="Status"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                    dense
                                    outlined
                                    label="Remark.."
                                    background-color="#FFFF"
                                    rows="4"
                                    v-model="main.remark"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="close_dialog()"
                        >
                            close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            :disabled="main.remark == '' || main.status == ''"
                            @click="update_case()"
                        >
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="dialog_part" persistent max-width="450">
                <v-card>
                    <v-card-title class="headline">
                        Update Status Part
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    label="Status"
                                    :items="['Good', 'Bad', 'DOA']"
                                    v-model="main_part.ce_status"
                                    required
                                    hide-details
                                    dense
                                    outlined
                                ></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="close_dialog_part()"
                        >
                            close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            :disabled="main_part.ce_status == ''"
                            @click="update_part()"
                        >
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import ViewMore from "../../Inventory/components/ViewMore"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    components: {
        ViewMore,
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        async get_page(num) {
            this.dialog_loading = true
            const search = {
                search: this.form_search.search,
            }

            if (num != "...") {
                this.current_page = num
                let url =
                    `${process.env.VUE_APP_ROOT_API}/api/nonhp/waiting-hp/part?page=` +
                    num
                let { data } = await axios.post(url, search, this.tk)
                this.dialog_loading = false
                this.data_case = data
            }
        },
        async back() {
            this.dialog_loading = true
            const search = {
                search: this.form_search.search,
            }

            let url = this.data_case.prev_page_url
            let { data } = await axios.post(url, search, this.tk)
            this.dialog_loading = false
            this.data_case = data
        },
        async next() {
            this.dialog_loading = true
            const search = {
                search: this.form_search.search,
            }

            let url = this.data_case.next_page_url
            let { data } = await axios.post(url, search, this.tk)
            this.dialog_loading = false
            this.data_case = data
        },
        page_num_show(n) {
            this.select_page = this.data_case.current_page
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_case.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_case.last_page - 1
                } else if (
                    this.data_case.current_page == this.data_case.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_case.last_page - 3
                    chk5 = this.data_case.last_page - 2
                    chk6 = this.data_case.last_page - 1
                } else if (this.data_case.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_case.last_page - 1
                } else if (
                    this.data_case.current_page ==
                    this.data_case.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_case.last_page - 3
                    chk5 = this.data_case.last_page - 2
                    chk6 = this.data_case.last_page - 1
                } else if (this.data_case.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_case.last_page - 1
                } else if (
                    this.data_case.current_page ==
                    this.data_case.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_case.last_page - 3
                    chk5 = this.data_case.last_page - 2
                    chk6 = this.data_case.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_case.current_page - 1
                    chk4 = this.data_case.current_page
                    chk5 = this.data_case.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_case.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_case.current_page <= 4) {
                    return this.data_case.current_page === n ? "primary" : ""
                } else if (
                    this.data_case.current_page == this.data_case.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_case.current_page ==
                    this.data_case.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_case.current_page ==
                    this.data_case.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_case.current_page === n ? "primary" : ""
            }
        },
        clear_data() {
            this.form_search.search = ""
            this.get_data()
        },
        async get_data() {
            this.dialog_loading = true

            this.mutateIsLoading()
            const search = {
                search: this.form_search.search,
            }

            await axios
                .post(url + "nonhp/waiting-hp/part", search, this.tk)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_case = response.data
                    this.mutateIsLoading()
                    this.page_total = response.data.last_page
                    this.page_total < 7
                        ? (this.page_count = this.page_total)
                        : (this.page_count = 7)
                    this.select_page = 1
                    // this.get_page(this.select_page)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        open_update_case(maincase_id, subcase_id) {
            this.main.maincase_id = maincase_id
            this.main.subcase_id = subcase_id
            this.dialog = true
        },
        close_dialog() {
            this.dialog = false
            this.main.maincase_id = ""
            this.main.subcase_id = ""
            this.main.remark = ""
            this.main.status = ""
        },
        async update_case() {
            this.dialog_loading = true
            await axios
                .post(url + "nonhp/waiting-hp/update-case", this.main, this.tk)
                .then((response) => {
                    this.get_data()
                    this.close_dialog()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        open_update_part(part_issue_id) {
            this.main_part.part_issue_id = part_issue_id
            this.dialog_part = true
        },
        close_dialog_part() {
            this.main_part.part_issue_id = ""
            this.main_part.ce_status = ""
            this.dialog_part = false
        },
        async update_part() {
            await axios
                .post(
                    url + "nonhp/waiting-hp/update-part",
                    this.main_part,
                    this.tk
                )
                .then((response) => {
                    this.get_data()
                    this.close_dialog_part()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        async export_data() {
            this.chk_export_data = true
            await axios({
                url: url + "nonhp/waiting-hp/part/export",
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        chk_btn(data) {
            let chk_status = false
            if (data.length == 1) {
                data[0].ce_status == "" || data[0].ce_status == null
                    ? (chk_status = true)
                    : (chk_status = false)
            } else {
                data.map((each) => {
                    chk_status =
                        each.ce_status == "" || each.ce_status == null
                            ? true
                            : chk_status
                })
            }
            return chk_status
        },
    },
    data() {
        return {
            form_search: {
                search: "",
            },
            chk_export_data: false,
            data_case: [],
            main: {
                maincase_id: "",
                subcase_id: "",
                remark: "",
                status: "",
            },
            main_part: {
                part_issue_id: "",
                ce_status: "",
            },
            dialog: false,
            dialog_part: false,
            text: "Success, Your work has been saved",
            page_count: 0,
            page_total: 0,
            select_page: 0,
            dialog_loading: false,
        }
    },
}
</script>
